<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10itiC1/tc-custom/9781646566532.jpg?1723404248163" alt="This image is the cover for the book The Deal Breaker"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Deal Breaker
      </h1>
      <p class="bookDescription body article font2">
        <p>What do you do when you're a popular porn star and the love of your life is deeply religious and totally closeted? Why, you keep your true identity from him, create an alternate reality, and hope he doesn't find out, of course. Because, if he ever does, that would be the deal breaker. That was Jordan Hearst's reasoning, anyway. However, despite Jordan's best efforts at keeping his charade a secret, Spenser Hudson does find out.<br/><br/>Having a liar and a porn star as a boyfriend is a deal breaker as far as the devastated Spenser is concerned. Fearing the loss of both his job and his family, Spenser abruptly disappears from Jordan's life, castigating himself for ever letting his carnal desires override his faith, thus allowing him to fall in love with the handsome, charming Jordan.<br/><br/>With all attempts at reconciliation rebuffed, Jordan tries to move on, but the love he feels for Spenser won't go away, making it impossible for him to return to his job of having meaningless sex in front of the cameras.<br/><br/>Spenser is given a different perspective on his and Jordan's situation from an unlikely source. Can the love he still feels for Jordan be the key to rekindling what they once shared? Is it enough to make Spenser see there's more than one way to look at the deal life has given him? Can a new deal to be struck?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terry O'Reilly
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50289d59